import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api";

export interface CustomerResult {
  id: number;
  name: string;
  phone: string | null;
  email: string | null;
}

/**
 * Typeahead search for customers by name, phone, or email.
 * Fires only when query is 2+ characters.
 */
export function useCustomerSearch(query: string) {
  const q = query.trim();
  return useQuery<CustomerResult[]>({
    queryKey: ["customers", "search", q],
    queryFn: () =>
      apiGet<CustomerResult[]>(
        `/customers?q=${encodeURIComponent(q)}&limit=8`,
      ),
    enabled: q.length >= 2,
    staleTime: 30_000,
    placeholderData: [],
  });
}
